import React, { createContext, useContext, useEffect, useState } from 'react';

interface AudioContextType {
  audioContext: AudioContext | null;
}

const AudioContextContext = createContext<AudioContextType>({
  audioContext: null,
});

export const useAudioContext = () => useContext(AudioContextContext);

interface AudioContextProviderProps {
  children: React.ReactNode;
}

export const AudioContextProvider: React.FC<AudioContextProviderProps> = ({ children }) => {
  const [audioContext, setAudioContext] = useState<AudioContext | null>(null);

  useEffect(() => {
    // Create AudioContext on mount
    const context = new AudioContext();
    setAudioContext(context);

    return () => {
      // Cleanup on unmount
      if (context.state !== 'closed') {
        context.close();
      }
    };
  }, []);

  return (
    <AudioContextContext.Provider value={{ audioContext }}>
      {children}
    </AudioContextContext.Provider>
  );
};
